import * as React from 'react'

function SvgSy(props) {
	return (
		<svg viewBox="0 0 180 120" width="1em" height="1em" {...props}>
			<path d="M0 0h180v120H0z" />
			<path fill="#fff" d="M0 0h180v80H0z" />
			<path fill="#ce1126" d="M0 0h180v40H0z" />
			<g id="sy_svg__d" fill="#007a3d">
				<g id="sy_svg__c">
					<g id="sy_svg__b">
						<path d="M54 47v13h8" transform="rotate(18 54 47)" id="sy_svg__a" />
						<use xlinkHref="#sy_svg__a" x={-108} transform="scale(-1 1)" />
					</g>
					<use xlinkHref="#sy_svg__b" transform="rotate(72 54 60)" />
				</g>
				<use xlinkHref="#sy_svg__b" transform="rotate(-72 54 60)" />
				<use xlinkHref="#sy_svg__c" transform="rotate(144 54 60)" />
			</g>
			<use xlinkHref="#sy_svg__d" x={72} />
		</svg>
	)
}

export default SvgSy
